import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import keycloak from './Keycloak';
import "./index.css";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <ReactKeycloakProvider
    initOptions={{ onLoad: 'login-required', checkLoginIframe: false }}
    authClient={keycloak}
    onEvent={(event, error) => {
      console.log('Keycloak event:', event, error);
      if (event === 'onTokenExpired') {
        console.log('Token expired event from provider - preventing automatic refresh');
        // Prevenir cualquier acción automática del provider
        return false;
      }
      // Capturar otros errores
      if (error) {
        console.error('Keycloak error:', error);
      }
    }}
    onTokens={(tokens) => {
      console.log('Tokens updated:', tokens);
    }}
  >
    <App />
  </ReactKeycloakProvider>,
  document.getElementById("root")
);

reportWebVitals();
//cambio para que me tome el pipeline
